import React from 'react';
import HalfTitleText from 'shared/half-title-text';

export default function TitleTextSplit(props) {
  return (
    <HalfTitleText {...props} />
  );
}
